export const getAlertBarNotification = (state) =>
  state.alertBar && state.alertBar.notification

export const isAlertBarDismissed = (state) =>
  state.alertBar && state.alertBar.isDismissed
